<div class="container">
    <h1 jhitranslate="students.title">
        <i class="fa fa-graduation-cap fa-pre" aria-hidden="true"></i>
        {{ 'student-list.title' | translate }}
    </h1>

    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">{{
                'student-list.search' | translate
            }}</label>
            <input
                class="form-control input-filter"
                id="search"
                type="text"
                [(ngModel)]="search"
                (ngModelChange)="searchStudents()"
                [placeholder]="'student-list.filterBy' | translate"
                #searchInput
            />
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr
                    class="text-center"
                    *ngIf="students.length < 1 && search.length > 1"
                >
                    <td colspan="8">
                        <i class="fa fa-spinner fa-spin fa-fw fa-5x"></i
                        >{{ 'student-list.list-loading' | translate }}
                    </td>
                </tr>
                <tr
                    class="text-center"
                    *ngIf="search.length < 1 && students.length === 0"
                >
                    <td colspan="8">
                        <i></i>{{ 'student-list.enter-search' | translate }}
                    </td>
                </tr>
                <tr
                    *ngIf="students.length > 0"
                    style="width: 100%; text-align: center;"
                >
                    <th>{{ 'student-list.lastName' | translate }}</th>
                    <th>{{ 'student-list.firstName' | translate }}</th>
                    <th>{{ 'student-list.company' | translate }}</th>
                    <th style="width:25%">
                        {{ 'student-list.email' | translate }}
                    </th>
                    <th>{{ 'student-list.city' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let student of students
                            | filterByFirstNameORLastNameORCompanyName: search
                    "
                    uiSref="student-detail"
                    [uiParams]="{ id: student.id }"
                >
                    <td>{{ student.lastName }}</td>
                    <td>{{ student.firstName }}</td>
                    <td style="min-width: 100px;">{{ student.companyName }}</td>
                    <td style="min-width: 100px;">{{ student.email }}</td>
                    <td style="min-width: 100px;">{{ student.city }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/student/student.component.html